import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9c7b1e8a")

_pushScopeId("data-v-9c7b1e8a")
const _hoisted_1 = {
  key: 0,
  id: "booking-v4-item-details-section",
  "data-testid": "booking-v4-item-details-section",
  class: "flex flex-col gap-1"
}
const _hoisted_2 = { class: "flex flex-col bg-red-lp-1300 bg-opacity-40 rounded-lg p-3 space-y-1" }
const _hoisted_3 = { class: "font-semibold text-xs" }
const _hoisted_4 = { class: "lg:col-span-6 flex items-center recommendation-container relative" }
const _hoisted_5 = { class: "grid grid-cols-3 gap-2 w-full" }
const _hoisted_6 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-8px px-1 py-0.5 flex-shrink-0"
}
const _hoisted_7 = {
  key: 1,
  class: "bg-red-lp-3100 rounded text-center text-red-lp-2400 font-medium text-8px px-1 py-0.5 flex-shrink-0"
}
const _hoisted_8 = { class: "text-xs text-black-lp-100 overflow-ellipsis whitespace-nowrap overflow-hidden text-12px" }
const _hoisted_9 = { class: "text-xs text-gray-lp-800 overflow-ellipsis whitespace-nowrap overflow-hidden text-12px" }
const _hoisted_10 = { class: "ml-1 relative" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "flex-1" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommodityTooltip = _resolveComponent("CommodityTooltip")!

  return (_ctx.savedPackages.length)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("bookingV4.savedAddress.title")) + " " + _toDisplayString(_ctx.commoditiesLength), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.savedPackages, (pkg) => {
                return (_openBlock(), _createBlock("div", {
                  key: pkg.id || pkg.commodityCode
                }, [
                  _createVNode("label", {
                    "data-testid": `booking-v4-commodity-chip-${
                pkg.id || pkg.commodityCode
              }`,
                    class: [
                'border rounded-full px-4 py-2 flex items-center gap-1 cursor-pointer h-[38px] transition-colors',
                _ctx.disabledCommodity ? 'cursor-not-allowed opacity-50' : '',
                _ctx.isActiveCard(pkg)
                  ? 'border-black-lp-100'
                  : _ctx.isSelectedRecommendation(pkg)
                    ? 'border-red-lp-100 bg-pink-lp-200 text-red-lp-1600 font-semibold'
                    : 'border-gray-lp-400 bg-white text-black-lp-300 hover:bg-gray-lp-1800 hover:text-gray-lp-300',
              ],
                    onClick: ($event: any) => (_ctx.onChoose(pkg))
                  }, [
                    _createVNode("input", {
                      type: "radio",
                      name: `commodity-recommendation-v4`,
                      value: pkg.commodityCode,
                      checked: _ctx.isSelectedRecommendation(pkg),
                      id: `commodity-${pkg.commodityCode}-${pkg.id}`,
                      disabled: _ctx.disabledCommodity,
                      onChange: () => _ctx.onChoose(pkg),
                      class: "z-10 absolute opacity-0"
                    }, null, 40, ["value", "checked", "id", "disabled", "onChange"]),
                    (pkg.isQuarantine)
                      ? (_openBlock(), _createBlock("span", _hoisted_6, " K "))
                      : _createCommentVNode("", true),
                    (pkg.isDangerousGoods)
                      ? (_openBlock(), _createBlock("span", _hoisted_7, " DG "))
                      : _createCommentVNode("", true),
                    _createVNode("span", _hoisted_8, _toDisplayString(_ctx.displayName(pkg)), 1),
                    _createVNode("span", _hoisted_9, _toDisplayString(pkg.totalGrossWeight) + " kg ", 1),
                    _createVNode("span", _hoisted_10, [
                      _createVNode("img", {
                        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
                        onMouseenter: ($event: any) => (_ctx.toggleTooltip($event, pkg.commodityCode)),
                        onMouseleave: ($event: any) => (_ctx.toggleTooltip($event, pkg.commodityCode)),
                        src: 
                    _ctx.isOpenTooltipCommodity
                      ? require('@/app/ui/assets/svg/info-red.svg')
                      : require('@/app/ui/assets/svg/info.svg')
                  ,
                        alt: "info",
                        class: "cursor-pointer"
                      }, null, 40, ["onMouseenter", "onMouseleave", "src"])
                    ]),
                    _hoisted_11
                  ], 10, ["data-testid", "onClick"]),
                  _createVNode(_component_CommodityTooltip, {
                    ref: pkg.commodityCode,
                    pkg: pkg,
                    "customer-id": _ctx.customerId,
                    "display-name": _ctx.displayName
                  }, null, 8, ["pkg", "customer-id", "display-name"])
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})